import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/img/icons/long-arrow.svg'


const _hoisted_1 = { class: "container ptb-100" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "blog-card mb-50" }
const _hoisted_4 = { class: "blog-img round-10 overflow-hidden" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "blog-info" }
const _hoisted_7 = { class: "blog-metainfo list-style" }
const _hoisted_8 = { class: "position-relative d-inline-block" }
const _hoisted_9 = { class: "position-relative d-inline-block" }
const _hoisted_10 = { class: "fs-26 lh-36" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-xl-4 col-md-6",
          key: blog.id
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: blog.image,
                alt: "Image",
                class: "round-10 transition"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("ul", _hoisted_7, [
                _createElementVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, { to: "/posts-by-author" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(blog.author), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("li", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(blog.date), 1)
                ])
              ]),
              _createElementVNode("h3", _hoisted_10, [
                _createVNode(_component_router_link, { to: "/blog-details-left-sidebar" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(blog.title), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(_component_router_link, {
                to: "/blog-details-left-sidebar",
                class: "link style-one"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Read More "),
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1)
                ])),
                _: 1
              })
            ])
          ])
        ]))
      }), 128)),
      _cache[1] || (_cache[1] = _createStaticVNode("<ul class=\"page-nav list-style text-center\"><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"><i class=\"ri-arrow-left-s-line\"></i></a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle active\" href=\"#\"> 01 </a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"> 02 </a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"> 03 </a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"><i class=\"ri-arrow-right-s-line\"></i></a></li></ul>", 1))
    ])
  ]))
}